<div class="tooltip-left-container">
	<div class="code-list">
		<div class="app-link" [ngClass]="{'selected-tooltip': tooltip===selectedTooltip}" *ngFor="let tooltip of tooltips" (click)="onClickCode(tooltip)">{{tooltip.code}}</div>
	</div>
</div>
<div class="tooltip-right-container">
	<div *ngIf="selectedTooltip" [innerHTML]="selectedTooltip.html">
		
	</div>
	<div *ngIf="selectedTooltip&&selectedTooltip.fieldsHtml" class="tooltip-fields">
		<h4>Fields</h4>
		<div [innerHTML]="selectedTooltip.fieldsHtml"></div>
	</div>
</div>